import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 2.5em;
  font-weight: bold;
  margin: 0;
`;

export const Subtitle = styled.h2`
  font-size: 1.5em;
  margin: 0;
  font-weight: normal;
`;
